import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Dropdown, MenuItem, Button } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';
import ellipsize from 'ellipsize';

import ProductMappingModal from '../product-mapping-modal';

class ProgramDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      saving: false,
      removing: false,
      showProductMappingModal: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggleItem = this.handleToggleItem.bind(this);
    this.submitParams = this.submitParams.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleUnsave = this.handleUnsave.bind(this);
  }

  componentDidMount() {
    const { program } = this.props;
    if (program) {
      this.handleToggleItem(program);
    }
  }

  handleToggle(open) {
    if (open) {
      this.setState({ open });
    }
  }

  handleClickOutside() {
    this.setState({ open: false });
  }

  handleToggleItem(program) {
    this.props.onProgramChange(program);
    this.setState({ open: false });
  }

  submitParams() {
    this.props.onSubmit();
    this.setState({ showProductMappingModal: false });
  }


  handleSubmit() {
    /*
    const { tvProducts, products } = this.props;
    if (products.length > 0 && tvProducts.length > 0) {
      this.setState({ showProductMappingModal: true });
    } else {
      this.submitParams();
    }
    */
    this.submitParams(); // https://github.com/lumen-software/TruSales/issues/1104
  }

  handleSave() {
    this.setState({ saving: true });
    this.props.requestSave()
      .then(
        () => {
          this.setState({ saving: false });
        },
        () => {
          this.setState({ saving: false });
        },
      );
  }

  handleUnsave() {
    this.setState({ removing: true });
    this.props.requestUnsave()
      .then(
        () => {
          this.setState({ removing: false });
        },
        () => {
          this.setState({ removing: false });
        },
      );
  }

  render() {
    const {
      programs, program, disabled,
      disabledSubmit, tvProducts, products,
      showSaveButton, showUnsaveButton,
      disabledUnsave,
    } = this.props;
    const {
      open, showProductMappingModal, saving, removing,
    } = this.state;
    if (!programs || !program) {
      return null;
    }
    let btnLabel = 'TruVoice Program';
    if (program) {
      btnLabel = program.name;
    }
    const showDropdown = false;
    return (
      <span>
        <ProductMappingModal
          mappings={program.productMappings ? program.productMappings : {}}
          tvProducts={tvProducts}
          products={products}
          isOpen={showProductMappingModal}
          onClose={() => { this.setState({ showProductMappingModal: false }); }}
          onToggle={(tvProductId, tsProductId) => { this.props.onToggleProductMapping(program, tvProductId, tsProductId); }}
          onSubmit={this.submitParams}
        />
        <div className="btn-group">
          {programs.length > 1 && showDropdown &&
            <Dropdown
              id="program-dropdown"
              onToggle={this.handleToggle}
              disabled={disabled}
              open={open}
            >
              <Dropdown.Toggle disabled={disabled} onClick={this.handleClickOutside} bsStyle="default">
                {ellipsize(btnLabel, 30)}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {programs.map((prog) => {
                  const active = prog.program_id === program.program_id;
                  return (
                    <MenuItem
                      disabled={disabled}
                      key={prog.program_id}
                      active={active}
                      onSelect={() => { this.handleToggleItem(prog); }}
                    >
                      {prog.name}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          }
          {showSaveButton &&
            <Button bsStyle="default" disabled={disabled || disabledSubmit || saving} onClick={this.handleSave}>
              {!saving && <span>Save</span>}
              {saving && <span>Saving</span>}
            </Button>
          }
          {showUnsaveButton &&
            <Button bsStyle="default" disabled={disabled || disabledUnsave || removing} onClick={this.handleUnsave}>
              {!removing && <span>Remove Saved</span>}
              {removing && <span>Removing</span>}
            </Button>
          }
          <Button bsStyle="warning" disabled={disabled || disabledSubmit || saving} onClick={this.handleSubmit}>Submit</Button>
        </div>
      </span>
    );
  }
}

ProgramDropdown.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.shape({})),
  program: PropTypes.shape({}),
  tvProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disabled: PropTypes.bool,
  disabledSubmit: PropTypes.bool,
  disabledUnsave: PropTypes.bool,
  onProgramChange: PropTypes.func,
  onSubmit: PropTypes.func,
  showSaveButton: PropTypes.bool,
  showUnsaveButton: PropTypes.bool,
  onToggleProductMapping: PropTypes.func,
  requestSave: PropTypes.func,
  requestUnsave: PropTypes.func,
};
ProgramDropdown.defaultProps = {
  disabled: false,
  disabledSubmit: false,
  disabledUnsave: true,
  showSaveButton: false,
  showUnsaveButton: false,
  program: null,
  programs: [],
  onProgramChange: () => {},
  onSubmit: () => {},
  onToggleProductMapping: () => {},
  requestSave: () => Promise.reject(new Error('need handler')),
  requestUnsave: () => Promise.reject(new Error('need handler')),
};


export default (enhanceWithClickOutside(ProgramDropdown));
